import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
import { motion, AnimatePresence } from 'framer-motion';
export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Modelos',
    href: '#modelos'
  }, {
    name: 'Comparativa',
    href: '#comparativa'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-white py-5'}`} data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="flex justify-between items-center" data-id="element-33">
          {/* Logo */}
          <a href="#" className="flex-shrink-0" data-id="element-34">
            <img src="https://cdn.magicpatterns.com/uploads/vNGUiNwgY6GeirQwf8eShH/Domus_nuevo_logo_rojo_(1).png" alt="REMAX Domus Logo" className="h-10 w-auto" data-id="element-35" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-36">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-remax-dark hover:text-remax-red font-medium transition-colors" data-id="element-37">
                {link.name}
              </a>)}
            <Button variant="primary" href="#contacto" data-id="element-38">
              Contactar a Dwhight
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-remax-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-39">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-40" /> : <MenuIcon size={24} data-id="element-41" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-42">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-43">
            <div className="px-4 pt-2 pb-6 space-y-4 flex flex-col" data-id="element-44">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 text-base font-medium text-remax-dark hover:text-remax-red hover:bg-gray-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-45">
                  {link.name}
                </a>)}
              <div className="pt-2" data-id="element-46">
                <Button variant="primary" className="w-full" href="#contacto" onClick={() => setIsMobileMenuOpen(false)} data-id="element-47">
                  Contactar a Dwhight
                </Button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
};